<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" :disable-backdrop-click="loading">
    <div class="mx-auto w-full max-w-lg">
      <BaseVeeForm
        :action="storeAccProductTemplate"
        ensure-error-keys-camel-case
        v-slot="{ isPending, invalid }"
        class="space-y-8"
      >
        <BaseCard>
          <BaseCardHeader> Create Acc Product Template </BaseCardHeader>
          <BaseCardBody>
            <AccProductTemplateCreateForm
              ref="accProductTemplateForm"
              :disabled="isPending || loading"
            />
          </BaseCardBody>
          <BaseCardFooter>
            <div class="flex space-x-2">
              <BaseButton primary :disabled="invalid || isPending || loading">
                Create Template
              </BaseButton>
              <BaseButton
                type="button"
                primary
                outline
                :disabled="isPending || loading"
                @click="$refs.modal.close()"
              >
                Cancel
              </BaseButton>
            </div>
          </BaseCardFooter>
        </BaseCard>
      </BaseVeeForm>
    </div>
  </VModal>
</template>

<script>
import AccProductTemplateCreateForm from './AccProductTemplateCreateForm.vue';

export default {
  components: { AccProductTemplateCreateForm },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async storeAccProductTemplate() {
      try {
        this.loading = true;

        const formData = this.$refs?.accProductTemplateForm?.getFormData() || {};

        const accProductTemplateId = await this.$store.dispatch('admin/accProductTemplates/store', {
          formData,
        });

        this.$emit('created', accProductTemplateId);

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
